<template>
	<div>
		<div class="deposit-modal-spacing has-text-left">
			<div v-if="process_status === 'processing'" class="header-bar-global">
				{{ $t('funds.DEPOSIT_PROCESSING') }}
			</div>
			<div v-else-if="process_status === 'success'" class="header-bar-global">
				{{ $t('funds.DEPOSIT_SUCCESS') }}
			</div>
			<div v-else-if="process_status === 'error'" class="header-bar-global">
				{{ $t('funds.DEPOSIT_ERROR') }}
			</div>
			<div v-else-if="process_status === 'requested'" class="header-bar-global">
				{{ $t('funds.MORPHER_DEPOSIT_REQUESTED') }}
			</div>
			<div v-else-if="funds.step === 'swap'" class="header-bar-global">
				<button class="button back-btn" @click="closePayment()">
					<img src="@/assets/funds/arrow-left.svg" alt="Back" />
				</button>
    			{{ funds && funds.amount && funds.amount > 0 ? $t('funds.FINISH_DEPOSIT') : $t('funds.SWAP_TOKENS') }}
				
			</div>
			<div v-else-if="funds.step === 'swap_executing'" class="header-bar-global">
				{{ $t('funds.SWAP_EXECUTING') }}...
			</div>
			<div v-else-if="funds.step === 'swap_successful'" class="header-bar-global">
				
			</div>
			
			


			<div v-else class="header-bar-global">
				<button class="button back-btn" @click="closePayment()">
					<img src="@/assets/funds/arrow-left.svg" alt="Back" />
				</button>
				{{ $t('funds.DEPOSIT') + ' ' + funds?.currency?.toUpperCase() }}
			</div>

			<div v-if="depositDisabled">
				Due to the Ethereum Merge, crypto deposits are temporarily disabled.
			</div>
			<!-- payment requested - after submit to blockchain -->
			<div v-else-if="process_status === 'requested'" class="payment-flow_box">
				<div class="has-text-centered pending-img">
					<img src="@/assets/funds/block_search.svg" alt="pending icon" />
				</div>

				<div class="payment_provider_section">
					<div v-if="transaction_data && transaction_data.payload">
						<img :src="imageURL('@/img/funds/tokens/' + transaction_data.payload.purchase_crypto_currency.toLowerCase() + '.svg')
							" class="transaction_icon" />
					</div>

					<div class="provider_text">
						<div class="provider_header" v-if="transaction_data && transaction_data.payload">
							{{ transaction_data.payload.purchase_crypto_currency.toUpperCase() }}
						</div>
						<div class="provider_header" v-else>
							{{ $t('funds.MORPHER') }}
						</div>
						<p class="is-size-14">{{ $t('funds.CRYPTO_TRANSACTION_RECEIVED') }}</p>
					</div>
				</div>

				<!-- Back to Funds -->
				<button class="button flat-white-btn xlarge is-fullwidth mt-15" @click="cancelPurchase()">
					{{ $t('funds.CLOSE_PAYMENT') }}
				</button>
			</div>

			<!-- payment processing - after crypto deposit completed - waiting for deposit -->
			<div v-else-if="process_status === 'processing'" class="payment-flow_box">
				<div class="has-text-centered pending-img">
					<img src="@/assets/funds/processing.svg" alt="pending icon" />
				</div>

				<div class="payment_provider_section">
					<div v-if="transaction_data && transaction_data.payload">
						<img :src="imageURL('@/img/funds/tokens/' + transaction_data.payload.purchase_crypto_currency.toLowerCase() + '.svg')
							" class="transaction_icon" />
					</div>

					<div class="provider_text">
						<div class="provider_header" v-if="transaction_data && transaction_data.payload">
							{{ transaction_data.payload.purchase_crypto_currency.toUpperCase() }}
						</div>
						<div class="provider_header" v-else>
							{{ $t('funds.MORPHER') }}
						</div>
						<p class="is-size-14">{{ $t('funds.TRANSACTION_PROCESSING') }} {{ $t('funds.CLOSE_WINDOW') }}
						</p>
						<p class="is-size-7">
							{{ $t('funds.TRANSACTION_DETAILS') }} <a @click="cancelPurchase()">{{ $t('funds.FUNDS')
								}}</a>
						</p>
					</div>
				</div>

				<!-- Back to Funds -->
				<button class="button flat-white-btn xlarge is-fullwidth mt-15" @click="cancelPurchase()">
					{{ $t('funds.CLOSE_PAYMENT') }}
				</button>
			</div>

			<!-- payment success - after deposit completed -->
			<div v-else-if="process_status === 'success'" class="payment-flow_box">
				<div class="has-text-centered pending-img">
					<img src="@/assets/funds/success.svg" alt="Success checkmark image" />
				</div>

				<div class="transaction_details_section" v-if="transaction_data && transaction_data.payload">
					<div class="transaction_header">
						<img :src="imageURL('@/img/funds/tokens/' + transaction_data.payload.purchase_crypto_currency.toLowerCase() + '.svg')
							" class="transaction_icon" />
						{{ roundFormatterFloor(transaction_data.payload.purchase_total) }}
						{{ transaction_data.payload.purchase_crypto_currency }}
					</div>

					<div class="transaction_details_lines">
						<div class="transaction_details_line">
							<p class="has-text-weight-medium">
								{{ $t('funds.MPH_CONVERSION') }}
							</p>
							<p>{{ roundFormatterFloor(transaction_data.payload.purchase_amount_mph) }} MPH</p>
						</div>
						<div class="transaction_details_line">
							<p class="has-text-weight-medium">
								{{ $t('funds.MORPHER_FEES') }}
							</p>
							<p>
								{{ transaction_data.payload.purchase_fees == 0 ? '✨' : ''
								}}{{ formatAmount(transaction_data.payload.purchase_fees) }}
							</p>
						</div>
						<div class="transaction_details_line">
							<p class="has-text-weight-medium">
								{{ $t('funds.TOTAL_VALUE') }}
							</p>
							<p>${{ formatAmount(transaction_data.payload.purchase_total_usd) }}</p>
						</div>
					</div>
				</div>

				<!-- Back to Funds -->
				<button class="button flat-white-btn xlarge is-fullwidth mt-15" @click="cancelPurchase()">
					{{ $t('funds.CLOSE_PAYMENT') }}
				</button>
			</div>

			<!-- payment error -->
			<div v-else-if="process_status === 'error'" class="payment-flow_box">
				<div class="has-text-centered pending-img">
					<img src="@/assets/funds/error.svg" alt="payment error" />
				</div>

				<div class="payment_provider_section">
					<div class="provider_text">
						<p class="is-size-14">
							{{ $t('funds.ERROR_TEXT') }}
							{{ $t('funds.ERROR_TRY_AGAIN') }}
						</p>
						<p class="is-size-7">
							{{ $t('funds.LEARN_MORE_DEPOSITS') }}
							<a target="_blank" :href="supportArticleLink('DepositMethod')">{{
								$t('funds.HERE')
							}}</a>.
						</p>
					</div>
				</div>

				<!-- Back to Funds -->
				<button class="button flat-white-btn xlarge is-fullwidth mt-15" @click="closePayment()">
					{{ $t('BACK') }}
				</button>

				
			</div>

			<!-- swap_executing -->
			<div v-else-if="funds.step === 'swap_executing'" >
				<div class="swap-executing">
					<img src="@/assets/funds/swap.gif" />
				</div>

				<div class="is-flex is-align-items-center is-flex-direction-column pt-24 " v-if="user?.wallet_type === 'metamask' || user?.wallet_type === 'walletconnect'">
					<img v-if="user?.wallet_type !== 'metamask' && walletIcon"  class="wallet-logo-other" :src="walletIcon" />
					<img v-else  class="wallet-logo" src="@/assets/icons/new/metamask-wallet.png" />

					<h1 class="get-mph-header mt-3">{{ $t('WALLET_SIGNATURE_HEAD') }}</h1>

					<p v-if="user?.wallet_type !== 'metamask' && walletName"  class="is-size-14 is-line-height-20 mt-3 mb-20 has-text-centered">{{ $t('WALLET_SIGNATURE_TEXT_OTHER', {wallet: walletName}) }}.</p>
					<p  v-else class="is-size-14 is-line-height-20 mt-3 mb-20 has-text-centered">{{ $t('WALLET_SIGNATURE_TEXT') }}.</p>

				</div>
				
			</div>

			<!-- swap_executing -->
			<div v-else-if="funds.step === 'swap_successful'" >
				<div class="swap-complete">
					<img src="@/assets/funds/swap-complete.svg" />
				</div>
				<div class="header-bar-global">
					{{ $t('funds.SWAP_COMPLETE') }}!
				</div>

				<div class="complete-amount">
					{{ roundFormatterFloor(swap_amount)  }} MPH 
				</div>

				<button class="button plain-primary-btn xlarge is-fullwidth mt-15" @click="closeDeposit()">
					{{ $t('DONE') }}
				</button>

			</div>

			
			<!-- swap amount  -->
			<div v-else-if="funds.step === 'swap'" >
				<div v-if="funds.amount && funds.amount > 0" class="deposit-subheading mt-15">
					{{ $t('funds.FINISH_DEPOSIT_1') }}<br />
					{{ $t('funds.FINISH_DEPOSIT_2', {token: funds.currency }) }}

				</div>

				<div v-if="funds.amount && funds.amount > 0" class="deposit_section mt-15 is-flex-direction-row">
					
					<div class="swap-header border">
						<div class="centered-flex-gap">
							<img v-if="currency.icon" :src="imageURL(`@/img/funds/tokens/${currency.icon.toLowerCase()}`)"
								class="provider-icon" />
							<div>
								<div class="has-text-grey-darker">
									{{ roundFormatterFloor(funds.amount)  }} {{funds.currency}}
								</div>
								<div class="payment-currency" v-if="!currExchange || currExchange === 0">
									{{ $t('funds.UNISWAP_CONVERT')}}
								</div>
								<div class="payment-currency" v-else>
									$ {{ usdFormatter(funds.amount * currExchange) }}
								</div>
							</div>
						</div>
					</div>
					<div class="swap-header pt-16">
						<div class="centered-flex-gap">
								<img v-if="currency.icon" :src="imageURL('@/img/funds/tokens/mph.svg')"
									class="provider-icon" />
								<div>
									<div class="has-text-grey-darker">
										{{ roundFormatterFloor(amountOut)  }}  MPH 
									</div>
									<div class="payment-currency">
										{{ $t('funds.UNISWAP_CONVERSION')}}
									</div>
								</div>
							</div>

					</div>

				</div>
				
				<div v-else>
					<div class="deposit-input">
						<div v-if="os !== 'ios'" class="currency-symbol" :style="{ order: 1 }">
							<img v-if="currency.icon" :src="imageURL('@/img/funds/tokens/' + currency.icon)"
									class="provider-icon-currency" />
						</div>
						<input v-if="os !== 'ios'" ref="deposit_amount" v-model="deposit_amount" class="deposit-amount"
							v-autowidth="{ maxWidth: '310px' , minWidth: '20px', comfortZone: '1ch' }"
							style="order: 2" />
						<input v-else ref="deposit_amount" v-model="deposit_amount" class="deposit-amount"
							style="width: 100% " />

					</div>
					<div class="is-flex is-align-items-center is-justify-content-center">
						<div class="payment-currency" >
							{{ $t('BALANCE')}} {{ roundFormatterFloor(token_balance || 0)  }}  {{ currency.id.toUpperCase() }}
						</div>
					</div>
					<div class="deposit_section mt-15">
						<div class="swap-header">
							<div class="centered-flex-gap">
								<img v-if="currency.icon" :src="imageURL('@/img/funds/tokens/mph.svg')"
									class="provider-icon" />
								<div>
									<div class="has-text-grey-darker">
										{{ roundFormatterFloor(amountOut)  }}  MPH 
									</div>
									<div class="payment-currency">
										{{ $t('funds.UNISWAP_CONVERSION')}}
									</div>
								</div>
							</div>

						</div>

					</div>
				</div>

				<div class="deposit_section no_padding mt-15">
					<div class="p-16 cost-section">
						<div class="swap-header">
							<div class="is-flex is-align-items-center is-justify-content-center">
								<img class="mr-8px" src="@/assets/icons/fees.svg">
								{{ $t('funds.NETWORK_COST') }}
								</div>
						</div>
						<div class="cost-detail-section border" v-if="pay_option == 'ETH'">
							<div class="is-flex is-justify-content-space-between">
								<div class="is-flex is-align-items-center is-justify-content-center">

									{{ $t('funds.NETWORK_GAS') }}
									<img class="cost-icon" :src="imageURL('@/img/funds/tokens/eth.svg')" />
								</div>
								<div class="amount-text">
									{{ networkFee }}
								</div>
								
							</div>
						</div>

						<div class="cost-detail-section border" v-else>
							<div class="is-flex is-justify-content-space-between">
								<div class="is-flex is-align-items-center is-justify-content-center">

									{{ $t('funds.NETWORK_GAS') }}
									<img class="cost-icon" :src="imageURL('@/img/funds/tokens/mph.svg')" />
								</div>
								<div class="amount-text">
									{{ conversionFee }}
								</div>
								
							</div>
						</div>
						<div class="cost-detail-section"  v-if="pay_option == 'ETH'">
							<div class="is-flex is-justify-content-space-between">
								<div class="is-flex is-align-items-center is-justify-content-center">

									{{ $t('funds.MORPHER_FEE') }}
									<img class="cost-icon" :src="imageURL('@/img/funds/morpher.svg')" />

									</div>
									<div class="amount-free">
										{{ $t('funds.FREE') }}
									</div>
							</div>
						</div>
						<div class="cost-detail-section" v-else>
							<div class="is-flex is-justify-content-space-between">
								<div class="is-flex is-align-items-center is-justify-content-center">
									{{ $t('funds.MORPHER_MPH_GAS_DEPOSIT') }}
								</div>
							</div>	
						</div>
					</div>
					<div class="pay-section">
						<div class="pay-selector border" :class="{selected: pay_option == 'MPH'}"  @click="switchPayOption">
							<!-- <img class="provider-icon" :src="imageURL('@/img/funds/tokens/mph.svg')" /> -->
							<span>{{ $t('funds.PAY_MPH') }}</span>
						</div>
						<div  class="pay-selector" :class="{selected: pay_option == 'ETH'}" @click="switchPayOption" >
							<!-- <img class="provider-icon" :src="imageURL('@/img/funds/tokens/eth.svg')" /> -->
							<span>{{ $t('funds.PAY_ETH') }}</span>
						</div>
					</div>
					
				</div>
				<div v-if=" pay_option == 'ETH' && gasBalance < 8* 10**12 " class="is-red-text mt-20 mb-20 has-text-centered font-12">
					{{ $t('PAY_ETH_BALACE') }}
				</div>



				

				<button  :class="{'is-loading':swapExecuting}" :disabled="(pay_option === 'MPH' && funds?.currency?.toUpperCase() === 'ETH') || !deposit_amount || deposit_amount > token_balance || deposit_amount_fees || ((token_balance || 0) == 0) || (pay_option == 'ETH' && gasBalance < 8* 10**12) || (pay_option == 'MPH' && currency && !mph_supported.includes(currency.id))" class="button plain-primary-btn is-full-width xlarge mt-15  " @click="executeSwap">
					{{ $t('funds.SWAP_TOKENS') }}
				</button>

				<div v-if=" deposit_amount && deposit_amount > token_balance  " class="is-red-text mt-20 mb-20 has-text-left font-12 has-text-weight-bold">
					{{ $t('funds.DEPOSIT_AMOUNT_BALANCE', {
						symbol: funds?.currency?.toUpperCase(), amount: roundFormatterFloor(token_balance)
					}) }} 
				</div>
				<div v-else-if="pay_option === 'MPH' && funds?.currency?.toUpperCase() === 'ETH'" class="is-red-text is-bold mt-20 mb-20 has-text-centered font-12 has-text-weight-bold">
					{{ $t('funds.DEPOSIT_ETH_MPH') }}
				</div>
				<div v-else-if=" pay_option == 'MPH' && currency && !mph_supported.includes(currency.id)  " class="is-red-text mt-20 mb-20 has-text-left font-12 has-text-weight-bold">
					{{ $t('MPH_NOT_SUPPORTED', {currency: currency.id.toUpperCase()}) }}
				</div>
				<div v-else-if="deposit_amount_fees" class="is-red-text mt-20 mb-20 has-text-left font-12 has-text-weight-bold">
					{{ $t('funds.DEPOSIT_AMOUNT_FEES', {
						symbol: funds?.currency?.toUpperCase(), amount: roundFormatterFloor(min_deposit_amount)
					}) }} 
				</div>
				<div v-else-if="swapError" class="is-red-text is-bold mt-20 mb-20 has-text-centered font-12 has-text-weight-bold">
					{{ swapError }}
				</div>
				<div class="consent_section mt-15">
					<p>
						{{ $t('funds.CONSENT_TOKEN') }}
						<a class="transition-faster" @click="showPurchaseAgreement()">{{
							$t('funds.TOKEN_PURCHASE_AGREEMENT') }}</a>
					</p>
				</div>
			</div>

			<!-- new crypto payment  -->
			<div v-else>
				<div v-if="deposit_address && chainName !== 'new'" class="has-text-centered">
					<VueQrcode :value="deposit_address.deposit_eth_address" :options="{ width: 200 }" />
				</div>
				<div v-if="user?.eth_address  && chainName === 'new' " class="has-text-centered">
					<VueQrcode :value="user?.eth_address" :options="{ width: 200 }" />
				</div>

				<div class="deposit_section no-padding">
					<div class="provider-header " @click="showCurrency()">
						<div class="centered-flex-gap">
							<img v-if="currency.icon" :src="imageURL('@/img/funds/tokens/' + currency.icon)"
								class="provider-icon" />
							<div>
								<div class="has-text-grey-darker">
									{{ currency.name }}
								</div>
								<div class="payment-currency">
									{{ currency.symbol }}
								</div>
							</div>
						</div>

						<img src="@/assets/funds/arrow-right.svg" />
					</div>

					<div class="wallet-details mt-15">
						<div class="wallets">
							<p class="wallet-headers">
								{{ $t('funds.WALLET_ADDRESS') }}
							</p>
							<p class="wallet-address" v-if="deposit_address && chainName !== 'new' ">
								{{ deposit_address.deposit_eth_address }}
							</p>
							<p class="wallet-address" v-if="user?.eth_address  && chainName === 'new' ">
								{{ user.eth_address }}
							</p>
						</div>

						<button class="button back-btn ml-1" @click="copyAddress()">
							<img src="@/assets/funds/copy.svg" class="copy-icon" />
						</button>
					</div>

					<div class="provider_learn_more is-flex is-align-items-center has-text-darkgrey deposit-gradient">
						<img class="mr-1" src="@/assets/icons/new/base.svg" />
						<p class="ml-5px">
							{{ $t('funds.DEOSIT_NETWORK', {
								network: $t('chains.' + currency?.chain?.toUpperCase() + '')
							}) }}
						</p>
					</div>
				</div>
				<div class="deposit_section mt-15" v-if="chainName == 'new'">
					<div class="swap-header">
						<div class="centered-flex-gap">
							<img v-if="currency.icon" :src="imageURL('@/img/funds/tokens/' + currency.icon)"
								class="provider-icon" />
							<div>
								<div class="has-text-grey-darker">
									{{ roundFormatterFloor(token_balance || 0)  }}  {{ currency.id.toUpperCase() }}
								</div>
								<div class="payment-currency" v-if="(token_balance || 0) > 0">
									{{ $t('BALANCE')}}
								</div>
								<div class="payment-currency" v-if="!refreshTimeout"> 
									<a v-if="!refreshTimeout" href="#" @click.native="() => refreshBalance()">
										{{ $t('REFRESH_BALANCE')}}
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
											<path d="M13.6354 8.59512C13.4502 10.3351 12.4643 11.9655 10.833 12.9074C8.12269 14.4722 4.65701 13.5436 3.0922 10.8332L2.92554 10.5446M2.36417 7.40443C2.54937 5.6645 3.53523 4.03401 5.16655 3.09217C7.87688 1.52736 11.3426 2.45599 12.9074 5.16631L13.074 5.45499M2.32886 12.0438L2.81689 10.2224L4.63826 10.7105M11.3617 5.28909L13.183 5.77713L13.6711 3.95576" stroke="#1A6DF0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</a>
									
								</div>
							</div>
						</div>

						<button  :class="{'is-loading':balanceLoading}" :disabled="(token_balance || 0) == 0" class="button plain-blue-btn xlarge  " @click="showSwap">
							{{ $t('SWAP') }}
						</button>
					</div>

				</div>
				<div class="consent_section mt-15">
					<p>
						{{ $t('funds.CONSENT_TOKEN') }}
						<a class="transition-faster" @click="showPurchaseAgreement()">{{
							$t('funds.TOKEN_PURCHASE_AGREEMENT') }}</a>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import PaymentMixin from '@/mixins/payment.mixin';
import { TransactionService } from '@/services/TransactionService';
import { getCurrencyList } from '@/helpers/funding';
import { UserService } from '@/services/UserService';
import type { FundsState } from '@/helpers/types';
import { parse } from '@/helpers/uaparser';
import { mapState, mapActions } from 'pinia';
import { useMarketsStore } from '@/store/modules/markets';
import { useUserStore } from '@/store/modules/user';
import { getUniswapQuote, swapTokenForToken, swapEthForToken, getSwapOutputAmount, getUniswapQuoteStatic } from '@/helpers/uniswap/univarsal_router'
import { ESideChainTransaction, getContract, getPublicClient, getPublicClientLocal, getTokenContract } from '@/helpers/viem';
import type { ISwapParams, ISwapParamsNew, TTokenInfo }from '@/helpers/uniswap/types'
import type { SwapTokenToMphPermittedInput, TAddress } from '@/types/graphql-global-types';
import { SafeAccountV0_3_0 as SafeAccount,
    type MetaTransaction,
    calculateUserOperationMaxGasCost,
    CandidePaymaster,
 } from "abstractionkit";
import { useModalsStore } from '@/store/modules/modals';
import { encodeFunctionData, getAddress, hexToSignature, parseSignature, toHex } from 'viem';
import { morpherTokenAbi } from '@/contracts/abis';
import { useContractStore } from '@/store/modules/contract';
import type { TMessageDomain, TSignMessage }from '@/helpers/types'
import EventBus from '@/store/event-bus';

/* @group Application_View */
/*
  <h4> <b> Fund Account Pages </b> </h4>
  <br>
  <br> Dedicated routes for deposit and withdrawal flows.
  <br> Works in conjunction with PortfolioFunds page.
*/
export default defineComponent({
	name: 'PaymentTypeMorpher',
	mixins: [PaymentMixin],
	components: {
		VueQrcode
	},
	props: {
		currencySymbol: {
			type: String,
			required: true
		},
		maxLeft: {
			type: Number,
			required: true
		},
		currencyExchange: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			depositDisabled: false,
			token_balance: 0,
			refreshTimeout: false,
			balanceLoading: false,
			os: '',
			deposit_amount: 0,
			exchange_rate: 0,
			ethExchange: 0,
			currExchange: 0,
			conversionCost: 0.000545,
			transactionCost: 0.000006,
			quotetimeout: null as any,
			quoteExecuting: false,
			token_address: [],
			swapExecuting: false,
			swap_amount: 0,
			mph_supported: ['eth', 'usdc'],
			swapError: ''
		};
	},
	computed: {
		...mapState(useUserStore, {
			chainName: (state) => state.chainName,
			pay_option: (state) => state.pay_option,
			gasBalance: (state) => state.gasBalance,
			activePortfolio: state => state.activePortfolio,
			token_addresses: state => state.data?.token_addresses,
		}),
		...mapState(useMarketsStore, {
			markets: (state) => state.data,
		}),
		...mapState(useContractStore, {
			provider: state => state.provider,
			walletName: (state) => state.walletName,
			walletIcon: (state) => state.walletIcon,
		}),

		mph_fees() {
				
			if (this.chainName !== 'new' || this.gasBalance < 8* 10**12 || this.pay_option === 'MPH') {
				return 100 
			} else {
				return 0
			}

		
		},
		
		currency() {
			if (!this.funds.chain || !this.funds.currency) {
				return {};
			}
			const currency: any = getCurrencyList(this.chainName).crypto.find(
				crypto =>
					crypto.chain == this.funds.chain &&
					crypto.provider == 'morpher' &&
					crypto.id.toUpperCase() == this.funds?.currency?.toUpperCase()
			) || {};


			return currency;
		},
		min_deposit_amount() {

			if (this.exchange_rate && this.exchange_rate > 0) {
				return 100 / this.exchange_rate
			} else {
				return 0
			}
		},

		deposit_amount_fees() {
			if (this.exchange_rate && this.exchange_rate > 0 && this.deposit_amount * this.exchange_rate - this.mph_fees < 0 ) {
				return true
			} else {
				return false
			}
		},
		amountOut() {
			if (!this.deposit_amount) {
				return 0
			}
			if (this.deposit_amount * this.exchange_rate - this.mph_fees < 0 ) {
				return 0
			}
			return this.deposit_amount * this.exchange_rate  - this.mph_fees
			
		},
		conversionFee() {
			if (this.pay_option == 'ETH') {
				return '$ ' + this.usdFormatter(0)	
			}
			const amount= (this.ethExchange || 0) * (this.conversionCost || 0)
			return '$ ' + this.usdFormatter(amount)
		},
		networkFee() {
			const amount= (this.ethExchange || 0) * (this.transactionCost || 0)
			return '$ ' + this.usdFormatter(amount)
		}
	},
	watch: {
		user_wallet_addresses(nv) {
			this.updateBalance();
		},
		'funds.step'(nv) {
			this.getQuote()
		},
		deposit_amount(nv) {
			if (this.deposit_amount && this.deposit_amount > 0 ) {
				this.getQuote()
			}
		},
		'funds.currency'(nv) {
			if (this.funds.currency) {
				const market_data = this.markets.find((market_find) => market_find?.type === 'crypto' && market_find?.symbol === this.funds.currency?.toUpperCase() );
				if (market_data) {
					this.currExchange = Number(market_data.close || 0)
				} else {
					this.currExchange = 0
				}	
			} else {
				this.currExchange = 0
			}
		},

	},

	async mounted() {
		this.process_status = 'new';

		UserService.sendAnalytics({
			event: 'begin_checkout',
			data: {
				currency: this.funds.currency,
				network: this.funds.chain,
				transaction_id: '',
				value: 0,
				provider: 'morpher',
				
			}
		});

		
		if (!this.deposit_address || !this.deposit_address.deposit_eth_address) {
			await this.createDepositAddress();
		}

		const browser = parse(navigator.userAgent);

		this.os = browser.os.toLowerCase();
		if (this.os == 'ipad' || this.os == 'iphone') {
			this.os = 'ios';
		}

		this.updateBalance()

		this.getQuote()

		const market_data = this.markets.find((market_find) => market_find?.type === 'crypto' && market_find?.symbol === 'ETH' );
		if (market_data) {
			this.ethExchange = Number(market_data.close || 0)
		}

		if (this.funds.currency) {
			const market_data = this.markets.find((market_find) => market_find?.type === 'crypto' && market_find?.symbol === this.funds.currency?.toUpperCase() );
			if (market_data) {
				this.currExchange = Number(market_data.close || 0)
			} else {
				this.currExchange = 0
			}	
		} else {
			this.currExchange = 0
		}

	},
	methods: {
		...mapActions(useUserStore, {
			getSwapAmount: 'getSwapAmount',
			switchPayOption: 'switchPayOption',
		}),
		...mapActions(useModalsStore, {
			toggleWalletSignatureModal: 'toggleWalletSignatureModal'
		}),

		async executeQuote() {
			try {
				this.quoteExecuting = true;
				const publicClient = getPublicClient(this.user?.blockchain_info || undefined)

				

				let chainId = import.meta.env.VITE_CHAIN_ID_NEW
				const destination = import.meta.env['VITE_TOKEN_' + chainId];
				let curr = this.currency.id.toUpperCase()
				if (curr == 'ETH' ) curr = 'WETH'
				let token_address: any = this.token_address.find((t: any) => t.symbol == curr)

				if (token_address) {
					let token_info = this.token_addresses?.find(addr => addr.eth_address?.toLowerCase() === token_address.eth_address?.toLowerCase())
					if (token_info) {
						this.exchange_rate = token_info.mph_rate || 0;

						let tokenIn: TTokenInfo = {
							address: (token_info.eth_address || '0x') as TAddress,
  							name: token_info.name || '',
  							symbol: token_info.symbol || '',
  							decimals: token_info.decimals || 18,
							eth_address: this.user?.eth_address as TAddress,
							balance: BigInt(Math.round(this.token_balance * 10**(token_info.decimals || 18)))
						}

						let tokenOut: TTokenInfo = {
							address: destination as TAddress,
  							name: 'Morpher Token',
  							symbol: 'MPH',
  							decimals: 18,
							eth_address: this.user?.eth_address as TAddress,
							balance: 0n
						}

						const quote = await getUniswapQuoteStatic(tokenIn, tokenOut, this.deposit_amount, publicClient, token_info.path)

						this.exchange_rate = quote.exchangeRate || 0;

					} else {
						const  src = token_address.eth_address
						const quote = await getUniswapQuote(src, destination, this.deposit_amount, publicClient)

						this.exchange_rate = quote.exchangeRate || 0;

					}

					
				}

				this.quoteExecuting = false;
			} catch (err:any) {
				this.exchange_rate = 0
			}

		},
		async getQuote () {
			if (this.funds.step == 'swap' && !this.quoteExecuting) {
				if (this.exchange_rate == 0) {
					this.executeQuote()
				} else {
					if (this.quotetimeout) {
						clearTimeout(this.quotetimeout)
					}
					this.quotetimeout = setTimeout(() => {
						this.executeQuote()
					}, 2000)

				}
			}

			
			return
			

		},
		showCurrency() {
			this.openFunds({
				type: 'deposit',
				showPaymentMethod: false,
				showOfframpProvider: false,
				step: null,
				showPaymentType: null,
				withdraw_amount: 0,
				showWithdrawAddress: false,
				showWithdrawMethod: false,
				withdraw_page: '',
				withdraw_account: '',
				withdraw_account_name: '',
				source: ''
			} as FundsState);
		},
		updateBalance() {
			this.balanceLoading = false;
			if (this.user_wallet_addresses.token_address) {
				this.token_address = this.user_wallet_addresses.token_address
			}
			this.user_wallet_addresses.balances.forEach((balance: any) => {
				if (balance.network === this.currency.chain) {
					let token = balance.token
					if (!token && balance.network == 'base') token = 'ETH';
					if (!token && balance.network == 'polygon') token = 'POL';
					if (!token && balance.network == 'ethereum') token = 'ETH';
					if (!token && balance.network == 'binance') token = 'BNB';
					token = token.toUpperCase()
					if (token === this.currency.id.toUpperCase()) {
						this.token_balance = balance.balance / Math.pow(10, balance.decimals);
					}

				}
			});
			if (this.funds.amount && this.funds.amount > 0) {
				this.deposit_amount = this.funds.amount;
			}else if (this.token_balance > 0 && this.deposit_amount == 0) {
				this.deposit_amount = Number(this.roundFormatterFloor(Math.floor(this.token_balance * 1000000) / 1000000))
			}
		},
		refreshBalance() {
			this.refreshTimeout = true
			setTimeout(() => {
				this.refreshTimeout = false
			}, 20000)
			
			this.balanceLoading = true;
			this.loadAllWalletFundsAddresses(true);
		},
		showSwap() {
			this.updateFunds({step: 'swap'}as FundsState)

		},
		async signTypedData(message: TSignMessage) {
			if (!this.walletClient) {
				throw new Error("No wallet client for signing");
				
			}
			const signature = await this.walletClient.signTypedData(message);

			return signature
		},
		async getTokenPermit( name: string, tokenAddress: string, nonce: bigint, deadline: bigint, value: bigint, version: number) {
			try {

				if (!this.walletClient) return

				const chainId = this.user?.blockchain_info?.chain_id;

				// set the domain parameters
				const domain: TMessageDomain = {
					name: name,
					version: version.toString(),
					chainId: Number(chainId),
					verifyingContract: getAddress(tokenAddress) // Use checksummed address
				};

				// set the Permit type parameters
				const types = {
					EIP712Domain: [
						{
							name: 'name',
							type: 'string',
						},
						{
							name: 'version',
							type: 'string',
						},
						{
							name: 'chainId',
							type: 'uint256',
						},
						{
							name: 'verifyingContract',
							type: 'address',
						},
					],
					Person: [
						{
							name: 'name',
							type: 'string',
						},
						{
							name: 'wallet',
							type: 'address',
						},
					],
					Permit: [{
						name: "owner",
						type: "address"
					},
					{
						name: "spender",
						type: "address"
					},
					{
						name: "value",
						type: "uint256"
					},
					{
						name: "nonce",
						type: "uint256"
					},
					{
						name: "deadline",
						type: "uint256"
					},
					],
				};
				//Permit(address owner,address spender,uint256 value,uint256 nonce,uint256 deadline)


				// set the Permit type values
				const values = {
					owner: getAddress(this.user?.eth_address || ''),
					spender: getAddress(this.user?.blockchain_info?.swap_helper || ''),
					value:  value.toString(),
					nonce: toHex(nonce), // Use nonce directly (already bigint)
					deadline: deadline.toString(),
				};


				const signature: any = await this.signTypedData({ account: getAddress(this.user?.eth_address || ''), types, domain, message: values, primaryType: 'Permit' });

				if (signature) {
					const hexToSig = await hexToSignature(signature);

					const tokenPermit:SwapTokenToMphPermittedInput = {
						tokenAddress: tokenAddress,
						owner: getAddress(this.activePortfolio?.eth_address || ''),
						value: value.toString(),
						minOutValue: BigInt(0).toString(),
						deadline: Number(deadline),
						v: Number(hexToSig.v || 0),
						r: hexToSig.r,
						s: hexToSig.s,
					};

					return tokenPermit;

				}
			} catch (err: any) {
				console.log('getTokenPermit - Error: ', err.toString() ); // Corrected log message typo
				return undefined;
			}
		},
		async sendSwapGasless(swapParams: ISwapParams, currentTimestamp: any) {
			
			if (!this.walletClient || !(swapParams?.tokenIn)) return
			
			try {
				// Get necessary details from the token contract
				const tokenContract = await getTokenContract( this.user?.blockchain_info || undefined, this.walletClient, swapParams.tokenIn);
				const nonce: bigint = (await tokenContract.contract.read.nonces([this.user?.eth_address as TAddress])) as bigint;
				const name: string = String(await tokenContract.contract.read.name([]));
				const decimals = Number(await tokenContract.contract.read.decimals([]));
				let version = 1
				try {
					version = Number(await tokenContract.contract.read.version([]));
				} catch (err: any) {
					console.log('Error getting version', err.toString())
				}
				

				if (!currentTimestamp || currentTimestamp == 0) {
					currentTimestamp = Date.now()
				}
    			const deadline = BigInt(Math.round(currentTimestamp/1000) + 180);

				
				const getTokenPermit = await this.getTokenPermit(name, swapParams.tokenIn, nonce, deadline, BigInt(swapParams.amountIn * (10**decimals)), version);


				if (getTokenPermit) {
					let result = await TransactionService.swapTokenToMphPermitted({inputToken: getTokenPermit })
					
					if (result.data?.swapTokenToMphPermitted.success && result.data?.swapTokenToMphPermitted.transactionHash) {
						const swapHash = result.data?.swapTokenToMphPermitted.transactionHash
						const publicClient = getPublicClient(this.user?.blockchain_info)
						let chainId = import.meta.env.VITE_CHAIN_ID_NEW
						const token_address = import.meta.env['VITE_TOKEN_' + chainId];

						let swapAmount = await getSwapOutputAmount(swapHash,
								token_address,
      							(this.user?.eth_address || '0x') as TAddress,
      							publicClient)

						console.log('swapAmount', swapAmount, swapHash)

						this.swap_amount = swapAmount;

						this.updateFunds({step: 'swap_successful'}as FundsState)

						await this.getTokenUserData({
							loading: false,
							component: this
						});

					} else {

					}
					


				} else {
					this.updateFunds({step: 'swap'}as FundsState)

				}

			} catch (err: any) {
				console.log('err in sendSwapGasless', err.toString())
				this.updateFunds({step: 'swap'}as FundsState)

			}


		},
		async executeSwap() {
			if (!this.user?.eth_address) {
				return
			}
			this.swapError = ''
			this.updateFunds({step: 'swap_executing'}as FundsState)

			try {
				const publicClient = getPublicClient(this.user?.blockchain_info || undefined)

				this.swapExecuting = true;

				let chainId = import.meta.env.VITE_CHAIN_ID_NEW
				
				const destination: TTokenInfo = {
					address: import.meta.env['VITE_TOKEN_' + chainId],
  					name: 'Morpher Token',
  					symbol: 'MPH',
  					decimals: 18,
  					eth_address: this.user.eth_address as TAddress,
  					balance: BigInt(0)

				} 

				let curr = this.currency.id.toUpperCase()
				if (curr == 'ETH' ) {
					const swapParamsETHtoToken: ISwapParamsNew = {
	    				tokenOut: destination,
						amountIn: this.deposit_amount,
	    				recipient: this.user.eth_address as TAddress,
	    				slippageTolerance: 0.5,
	    				deadline: Math.floor(Date.now() / 1000) + 60 * 10
	  				};

					const gasBalance = this.user?.eth_address ?
						await publicClient.getBalance({
							address: this.user.eth_address as TAddress,
						}) : BigInt(0);


					if (swapParamsETHtoToken.amountIn <= Number(BigInt(10**14)) / 10**18 ) {
						this.swapExecuting = false;
						this.updateFunds({step: 'swap'}as FundsState)

						this.swapError = this.$t('SWAP_TOO_SMALL', {amount: Number(BigInt(10**14)) / 10**18})
						return
					}


					if (gasBalance &&  Number(gasBalance)  / 10**18 < swapParamsETHtoToken.amountIn + (Number(BigInt(10**14)) / 10**18)) {
						swapParamsETHtoToken.amountIn = (Number(gasBalance)  / 10**18) - (Number(BigInt(10**14)) / 10**18)
					}

		
					if (!this.walletClient.account) {
						this.walletClient.account = this.user.eth_address
					}

	  				// Execute ETH to token swap

	  				let swapResult = await swapEthForToken(swapParamsETHtoToken, publicClient, this.walletClient);

					this.swap_amount = swapResult.swapAmount

					console.log('swapResult.swapHash', swapResult.swapHash)
					if (swapResult.swapHash) {
						await TransactionService.saveSwap({
							tx_hash: swapResult.swapHash, chain_name: this.chainName, dest_address: this.funds.withdraw_account as TAddress
						})
					}

					this.updateFunds({step: 'swap_successful'}as FundsState)

					await this.getTokenUserData({
						loading: false,
						component: this
					});

					await this.loadAllWalletFundsAddresses(true);

					// Complete swap transactions and refresh swap amount
					try {
						await TransactionService.completeUserSwapTransactions({ eth_address: this.user.eth_address });
						await this.getSwapAmount({ type: 'purchase', eth_address: this.user.eth_address });
					} catch (swapError) {
						console.error('Error completing swap transactions or refreshing amount:', swapError);
						// Optionally show an error message to the user
					}

					EventBus.$emit('refreshFunds');
				} else {
					let token_address: any = this.token_address.find((t: any) => t.symbol == curr)
					

					if (token_address) {


						if (this.pay_option == 'MPH') {

							const swapParams: ISwapParams = {
								tokenIn: token_address.eth_address,
								tokenOut: destination.address, // 
								amountIn: this.deposit_amount,
								recipient: this.user.eth_address as TAddress,
								slippageTolerance: 0.5, // 0.5% slippage
								deadline: Math.floor(Date.now() / 1000) + 60 * 10 // 10 minutes from now
							};

							this.sendSwapGasless(swapParams, Date.now())
							
							
						} else {

							const destination: TTokenInfo = {
								address: import.meta.env['VITE_TOKEN_' + chainId],
								name: 'Morpher Token',
								symbol: 'MPH',
								decimals: 18,
								eth_address: this.user.eth_address as TAddress,
								balance: BigInt(this.balance.mph_sidechain)

							} 

			

							if (!this.walletClient.account) {
								this.walletClient.account = this.user.eth_address
							}

							let token_info = this.token_addresses?.find(addr => addr.eth_address?.toLowerCase() === token_address.eth_address?.toLowerCase())
							if (!token_info) {
								return
							}
							this.exchange_rate = token_info.mph_rate || 0;

							let tokenIn: TTokenInfo = {
								address: (token_info.eth_address || '0x') as TAddress,
								name: token_info.name || '',
								symbol: token_info.symbol || '',
								decimals: token_info.decimals || 18,
								eth_address: this.user?.eth_address as TAddress,
								balance: BigInt(Math.round(this.token_balance * 10**(token_info.decimals || 18)))
							}

							const swapParams: ISwapParamsNew = {
								tokenIn: tokenIn,
								tokenOut: destination, // 
								amountIn: this.deposit_amount,
								recipient: this.user.eth_address as TAddress,
								slippageTolerance: 0.5, // 0.5% slippage
								deadline: Math.floor(Date.now() / 1000) + 60 * 10 // 10 minutes from now
							};
	

							
							let swapResult = await swapTokenForToken(swapParams, publicClient, this.walletClient, token_info.path);

							this.swap_amount = swapResult.swapAmount;

							console.log('swapResult', swapResult)

							if (swapResult.swapHash) {
								await TransactionService.saveSwap({
									tx_hash: swapResult.swapHash, chain_name: this.chainName, dest_address: this.funds.withdraw_account as TAddress
								})
							}

							this.updateFunds({step: 'swap_successful'}as FundsState)

							await this.getTokenUserData({
								loading: false,
								component: this
							});

							await this.loadAllWalletFundsAddresses(true);

							EventBus.$emit('refreshFunds');
						}

					}
				}

				this.swapExecuting = false;

			} catch (err: any) {
				console.log('err', err)
				this.swapExecuting = false;
				this.swapError = this.$t('SWAP_ERROR')
				this.updateFunds({step: 'swap'}as FundsState)
			}
		},
		swapComplete() {
			this.updateFunds({step: 'swap_successful'}as FundsState)
		},
		closeDeposit() {
			this.closePayment()
			this.toggleDepositWithdrawModal(false);

		}
	}
});
</script>
<style>
.deposit_section a {
	color: #1A6DF0 !important;
}
</style>
<style scoped src="../../assets/css/payment.css"></style>
<style scoped>
.provider-header {
	font-size: 14px;
	font-weight: 700;
	border-bottom: 1px solid #eae9ed;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
	padding: 16px;
	transition: background-color 0.25s;
	border-radius: 7px 7px 0 0;
}

.swap-header {
	font-size: 14px;
	font-weight: 700;

	display: flex;
	align-items: center;
	justify-content: space-between;
	transition: background-color 0.25s;
}

.swap-header.border {
	border-bottom: 1px solid #EAE9ED;
	padding-bottom: 16px;

}

.provider-header:hover {
	background-color: #f5f5f5;
	cursor: pointer;
}

.provider-icon-currency {
	height: 24px;
	margin-top: 9px;
}
.provider-icon {
	height: 24px;
}

.payment-currency a {
	display: flex;
	gap: 5px;
	align-items: center;
}
.payment-currency {
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	color: #666666;
	
}

.centered-flex-gap {
	display: flex;
	align-items: center;
	gap: 5px;
}

.token_header {
	font-size: 16px;
	font-weight: bold;
	border-bottom: 1px solid #eae9ed;
	padding: 15px;
	cursor: pointer;
}

.token_icon_image {
	position: relative;
	top: 4px;
}
.is-full-width {
		width: 100%;
	}
.token_address_copy_icon {
	float: right;
	display: block;
	width: 25px;
	position: relative;
	top: -60px;
}
.deposit-input {
	max-width: 352px;
	margin-left: auto;
	margin-right: auto;
	display: flex;
	align-items: center;
	margin-top: 24px;
	justify-content: center;
}
.deposit-amount {

width: 100%;
border: 0;
text-align: center;
color: #333333;
font-size: 40px;
font-weight: 400;
font-family: 'Manrope';
}

.deposit-amount:focus {
outline: none;
}
.cost-detail-section {
	text-align: left;
	color: #686475;
	font-size: 12px;
	font-weight: 400;
	padding-top: 6px;
}
.cost-detail-section.border {
	padding-bottom: 6px;
	border-bottom:	1px solid var(--border-border-light, #EAECF0);
}
.cost-section {
 border-bottom:	1px solid var(--border-border-light, #EAECF0);
}
.p-16 {
	padding: 16px
}
.cost-icon {
	width: 16px;
	height: 16px;
	margin-left: 6px;
}
.pay-section {
	display: flex;
	justify-content:space-evenly
}
.pay-selector.selected {
	background:  #F9F9F9;
	color:  #1A6DF0;
	cursor: default	;
	
}
.pay-selector {
	display: flex;
	align-items: center;	
	justify-content: center;
	height: 40px;
	width: 50%;
	cursor: pointer;
	gap: 6px
}
.pay-selector.border {
	border-right: 1px solid #EAECF0;

}
.amount-free {
color: #039954;

font-size: 12px;
}
.swap-executing {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
}
.swap-complete {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 0px;
}
.complete-amount {
	
	color: #039954;
	font-size: 16px;
	text-align: center;
	font-weight: 400;

}
.deposit-subheading {
	color: #686475;
	text-align: center;
	font-size: 14px;
	font-weight: 400;
}
.pt-16 {
	padding-top: 16px;
}
.wallet-logo-other {
	width: 80px;
	height: 80px;
	border-radius: 20px;

}
.wallet-logo {
	width: 80px;
	height: 80px;
}


.get-mph-header {
	color: #333;
	font-size: 28px;
	font-weight: 700;
	line-height: 2.25rem;
}
.withdraw-message-error {
	color: #D70228;
}
.deposit-gradient {


	border-top: 1px solid #EAE9ED;

	background: linear-gradient(270deg, rgba(227, 235, 255, 0.50) 0%, rgba(227, 235, 255, 0.00) 100%), #FFF;
	
	border-radius: 0 0 7px 7px;
	color: #333333!important;
	font-weight: 700;
	line-height: 18px; 
	padding: 16px;


}

.wallet-details {
	padding-left: 16px;
	padding-right: 16px;
	padding-bottom: 12px;
}

.no-padding { 
	padding: 0 !important;
}

</style>
